import React from 'react';

import { IconButton, Skeleton } from '@mui/material';

import * as S from './styles';

const ImageCarouselSkeleton: React.FC = () => {
  return (
    <S.CarouselWrapper>
      <S.CarouselContainer>
        {[1, 2, 3].map(index => (
          <S.ImageCard key={index} active={false} width={210} height={280}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height="100%"
              animation="wave"
              sx={{
                bgcolor: 'rgba(255, 255, 255, 0.1)',
              }}
            />
          </S.ImageCard>
        ))}
      </S.CarouselContainer>
      <S.IndicatorWrapper>
        <IconButton disabled>
          <Skeleton variant="circular" width={16} height={16} />
        </IconButton>
        {[1, 2, 3].map(index => (
          <Skeleton
            key={index}
            variant="circular"
            width={8}
            height={8}
            sx={{
              bgcolor: 'rgba(255, 255, 255, 0.1)',
            }}
          />
        ))}
        <IconButton disabled>
          <Skeleton variant="circular" width={16} height={16} />
        </IconButton>
      </S.IndicatorWrapper>
    </S.CarouselWrapper>
  );
};

export default ImageCarouselSkeleton;
